import { render, staticRenderFns } from "./MedicalExaminationModal.vue?vue&type=template&id=4bbf9d66&"
import script from "./MedicalExaminationModal.vue?vue&type=script&lang=js&"
export * from "./MedicalExaminationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports